import { render, staticRenderFns } from "./printBox.vue?vue&type=template&id=77ecfa96&scoped=true"
import script from "./printBox.vue?vue&type=script&lang=js"
export * from "./printBox.vue?vue&type=script&lang=js"
import style0 from "./printBox.vue?vue&type=style&index=0&id=77ecfa96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ecfa96",
  null
  
)

component.options.__file = "printBox.vue"
export default component.exports